import script from "./tag-label.vue?vue&type=script&setup=true&lang=js"
export * from "./tag-label.vue?vue&type=script&setup=true&lang=js"

import "./tag-label.vue?vue&type=style&index=0&id=1ae6910a&lang=scss"
import "./tag-label.vue?vue&type=style&index=1&id=1ae6910a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ae6910a"]])

export default __exports__